import { render, staticRenderFns } from "./adjustAticleEdit.vue?vue&type=template&id=0ffc725d&scoped=true&"
import script from "./adjustAticleEdit.vue?vue&type=script&lang=js&"
export * from "./adjustAticleEdit.vue?vue&type=script&lang=js&"
import style0 from "./adjustAticleEdit.vue?vue&type=style&index=0&id=0ffc725d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc725d",
  null
  
)

export default component.exports